module.exports = {
	"header": "Contactez-nous",
	"generalInformation": "Information générale",
	"headerSmall": "Comment joindre $t(general::brand)?",
	"sales": "Vente",
	"support": "Soutien",
	"messageSent": "Message envoyé!",
	"paragraph1": "Nous sommes heureux de répondre à vos questions ou de vous fournir de l'assistance avec un de nos services. Vous n'avez qu'à utiliser le formulaire ci-dessous pour nous envoyer toute question.",
	"errors": {
		"noEmail": "$t(errors::user.emailRequired)",
		"noMessage": "Vous devez écrire un message!",
		"noName": "Vous devez fournir le nom du contact.",
		"noType": "Vous devez fournir un type de requête valide.",
		"noSubject": "Vous devez mettre l'objet de votre demande.",
		"sendingMessage": "Erreur lors de l'envoi du message."
	},
	"address": "Adresse",
	"email": "Courriel",
	"emailPlaceholder": "Saisir votre adresse courriel",
	"inquiryTypes": {
		"0": "Ventes",
		"1": "Soutien technique",
		"2": "Facturation",
		"3": "Marketing et relations"
	},
	"message": "Message",
	"messagePlaceholder": "Votre message pour nous...",
	"namePlaceholder": "Saisir votre nom",
	"phone": "Téléphone",
	"typeOfInquiry": "Type de requête",
	"subject": "Objet",
	"subjectPlaceholder": "Objet de votre demande",
	"submit": "Soumettre",
	"supportDays": "Lundi au vendredi",
	"supportHours": "8h à 18h - Heure de l'Est",
	"tollFree": "Sans frais",
	"confirmationMessage": {
		"header": "Confirmation de votre demande",
		"paragraph1": "Nous avons reçu votre demande. Un représentant vous contactera prochainement et répondra à vos questions."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/contact.json5
// module id = 1976
// module chunks = 6